import React from "react";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Christian Laviolette</h1>
        <p>Software Engineer & AI Specialist</p>
        <p>Portfolio website coming soon!</p>
      </header>
    </div>
  );
}

export default App;
